export const PLANS_ENDPOINT_KEY = 'plans'
